<template>
  <div>
    <div class="container-title mt-3 text-center">
      <div>
        {{
          $getVisibleNames("manual.matriz_4", true, "Matriz 4").toUpperCase()
        }}
      </div>
    </div>

    <!-- Matriz de Capacidades -->
    <b-table-simple bordered responsive class="table-capacity mt-3 mb-5">
      <b-thead>
        <b-tr>
          <b-th
            class="primary-cell-matrix4 competence-cell"
            style="
              width: 30%;
              background-color: var(--kl-color-accent-medium) !important; color: var(--kl-text-on-primary) !important;
            "
            >{{
              $getVisibleNames("mesh.competence", true, "Competencias")
            }}</b-th
          >
          <b-th
            class="primary-cell-matrix4"
            style="
              width: 15%;
              background-color: var(--kl-color-accent-medium) !important; color: var(--kl-text-on-primary) !important;
            "
            >{{
              $getVisibleNames(
                "mesh.formationline",
                false,
                "Línea De Formación"
              )
            }}</b-th
          >
          <b-th
            class="primary-cell-matrix4"
            style="
              width: 20%;
              background-color: var(--kl-color-accent-medium) !important; color: var(--kl-text-on-primary) !important;
            "
            >{{
              $getVisibleNames("mesh.egressprofilematter", false, "Asignatura")
            }}</b-th
          >
          <b-th
            class="primary-cell-matrix4"
            style="width: 2%; background-color: var(--kl-color-accent-medium) !important; color: var(--kl-text-on-primary) !important"
            >{{ $t("matrix4.matrix4View.level") }}</b-th
          >
          <b-th
            class="primary-cell-matrix4"
            style="background-color: var(--kl-color-accent-medium) !important; color: var(--kl-text-on-primary) !important"
            v-for="capacity in getListCapacities"
            :key="'capacity' + capacity.id"
          >
            {{ capacity.name }}
          </b-th>
        </b-tr>
      </b-thead>
      <b-tbody>
        <b-tr
          v-for="egress_profile_matter in egressProfileMattersFilter"
          :key="egress_profile_matter.id"
        >
          <b-td class="secondary-cell-matrix4 text-justify">
            <div
              v-for="competence in egress_profile_matter.competences"
              :key="'competence' + competence"
            >
              <p>{{ getCompetenceName(competence) }}</p>
            </div>
          </b-td>
          <b-td class="secondary-cell-matrix4">
            {{ getFormationLineName(egress_profile_matter.formation_line) }}
          </b-td>
          <b-td class="secondary-cell-matrix4">
            <b-link
              class="secondary-cell-matrix4"
              :to="{
                name: 'MatterProgramView',
                params: { matter_id: egress_profile_matter.id },
              }"
              v-b-tooltip.v-secondary.noninteractive="
                `${$t('reusable.common.goTo')} ${$getVisibleNames(
                  'manual.matter_program',
                  false,
                  'Programa de la Asignatura'
                )}`
              "
            >
              <span
                v-b-tooltip.v-secondary.noninteractive="
                  `${$getVisibleNames('manual.matter_code', false, 'Código')}`
                "
              >{{ getMatterCode(egress_profile_matter.matter) }}</span>
              <template
                v-if="
                  institution &&
                  institution.use_epm_code &&
                  egress_profile_matter.code &&
                  egress_profile_matter.code !== getMatterCode(egress_profile_matter.matter)
                "
              >
                -
                <span
                  v-b-tooltip.v-secondary.noninteractive="
                    `${$getVisibleNames('manual.ep_matter_code', false, 'Código')}`
                  "
                >{{ egress_profile_matter.code }}</span>
              </template>
              - {{ getMatterName(egress_profile_matter.matter) }}
            </b-link>
          </b-td>
          <b-td class="secondary-cell-matrix4">
            {{ egress_profile_matter.plan_level }}
          </b-td>
          <b-td
            class="secondary-cell-matrix4"
            v-for="capacity in getListCapacities"
            :key="'capacity_matter' + capacity.id"
          >
            <div v-if="egress_profile_matter.capacities.includes(capacity.id)">
              <b-icon
                icon="check"
                :style="{
                  color: '2b2a2a !important',
                }"
                width="25"
                height="25"
              ></b-icon>
            </div>
          </b-td>
        </b-tr>
      </b-tbody>
      <tr v-if="getListCapacities.length > 0">
        <td
          :colspan="4"
          class="footer-matrix4"
          style="background-color: var(--kl-color-accent-medium) !important; color: var(--kl-text-on-primary) !important"
        >
          {{ $t("matrix4.matrix4View.total").toUpperCase() }}
        </td>
        <b-td
          class="secondary-cell-matrix4 footer-matrix4"
          style="background-color: var(--kl-color-accent-medium) !important; color: var(--kl-text-on-primary) !important"
          v-for="capacity in getListCapacities"
          :key="'capacity_matter-footer' + capacity.id"
        >
          <div
            v-b-tooltip.v-secondary.noninteractive="
              `${$t('matrix4.matrix4View.quantityOf')} ${$getVisibleNames(
                'mesh.egressprofilematter',
                false,
                'Asignatura'
              )}`
            "
          >
            {{ getMatterCount(capacity.id) }}
          </div>
        </b-td>
      </tr>
    </b-table-simple>

    <b-table-simple
      v-if="getListCapacities.length > 0"
      bordered
      responsive
      striped
      class="table-capacity"
    >
      <b-thead>
        <b-tr>
          <b-th
            class="primary-cell-capacity"
            colspan="3"
            style="background-color: var(--kl-color-accent-medium) !important; color: var(--kl-text-on-primary) !important"
            >{{
              $getVisibleNames(
                "mesh.capacity",
                true,
                "Capacidades"
              ).toUpperCase()
            }}</b-th
          >
        </b-tr>

        <b-tr>
          <b-th
            class="primary-cell-capacity text-left"
            style="background-color: var(--kl-color-accent-medium) !important; color: var(--kl-text-on-primary) !important"
            >{{ $t("matrix4.matrix4View.definition").toUpperCase() }}:</b-th
          >
          <b-th
            class="primary-cell-capacity text-left"
            style="background-color: var(--kl-color-accent-medium) !important; color: var(--kl-text-on-primary) !important"
            >{{ $t("matrix4.matrix4View.description").toUpperCase() }}:</b-th
          >
          <b-th
            class="primary-cell-capacity text-center"
            style="background-color: var(--kl-color-accent-medium) !important; color: var(--kl-text-on-primary) !important"
            >{{
              $getVisibleNames(
                "mesh.egressprofilematter",
                true,
                "Asignaturas"
              ).toUpperCase()
            }}</b-th
          >
        </b-tr>
      </b-thead>

      <b-tbody>
        <b-tr
          v-for="capacity in getListCapacities"
          :key="'capacity_footer' + capacity.id"
        >
          <b-td class="text-left">{{ capacity.name }}</b-td>
          <b-td>
            <RenderVHtml :content="capacity.description"></RenderVHtml>
          </b-td>
          <b-td>
            <b-button
              size="sm"
              v-b-tooltip.v-secondary.hover="
                capacity.length > 0 ? $t('reusable.common.viewDetails') : ''
              "
              @click="$bvModal.show(`capacity-matters-modal-${capacity.id}`)"
            >
              <b-badge class="badge-footer" variant="secondary">
                {{ getMatterCount(capacity.id) }}
              </b-badge>
            </b-button>
            <!-- Modal al apretar boton de capacidades -->
            <b-modal
              :id="`capacity-matters-modal-${capacity.id}`"
              size="lg"
              hide-footer
            >
              <template #modal-title>
                <h6 class="mt-2">{{ capacity.name }}</h6>
              </template>
              <template>
                <b-table-simple responsive small bordered>
                  <b-thead>
                    <b-tr>
                      <b-th class="primary-cell-capacity-modal">
                        <div>{{ $t("matrix4.matrix4View.planLevel") }}</div>
                      </b-th>
                      <b-th class="primary-cell-capacity-modal">
                        <div>
                          {{
                            $getVisibleNames(
                              "mesh.egressprofilematter",
                              true,
                              "Asignaturas"
                            )
                          }}
                        </div>
                      </b-th>
                      <b-th class="primary-cell-capacity-modal">
                        <div>
                          {{
                            $getVisibleNames(
                              "manual.credits",
                              true,
                              "Créditos SCT Totales"
                            )
                          }}
                        </div>
                      </b-th>
                    </b-tr>
                  </b-thead>
                  <b-tbody>
                    <b-tr
                      v-for="egress_profile_matter in egressProfileMattersFilter.filter(
                        (x) => x.capacities.includes(capacity.id)
                      )"
                      :key="egress_profile_matter.id"
                    >
                      <b-td class="text-center">{{
                        egress_profile_matter.plan_level
                      }}</b-td>
                      <b-td>
                        <b-link
                          class="secondary-cell-matrix4"
                          :to="{
                            name: 'MatterProgramView',
                            params: { matter_id: egress_profile_matter.id },
                          }"
                          v-b-tooltip.v-secondary.noninteractive="
                            `${$t('reusable.common.goTo')} ${$getVisibleNames(
                              'manual.matter_program',
                              false,
                              'Programa de la Asignatura'
                            )}`
                          "
                        >
                          <span
                            v-b-tooltip.v-secondary.noninteractive="
                              `${$getVisibleNames('manual.matter_code', false, 'Código')}`
                            "
                          >{{ getMatterCode(egress_profile_matter.matter) }}</span>
                          <template
                            v-if="
                              institution &&
                              institution.use_epm_code &&
                              egress_profile_matter.code &&
                              egress_profile_matter.code !== getMatterCode(egress_profile_matter.matter)
                            "
                          >
                            -
                            <span
                              v-b-tooltip.v-secondary.noninteractive="
                                `${$getVisibleNames('manual.ep_matter_code', false, 'Código')}`
                              "
                            >{{ egress_profile_matter.code }}</span>
                          </template>
                          - {{ getMatterName(egress_profile_matter.matter) }}
                        </b-link>
                      </b-td>
                      <b-td class="text-center">
                        {{
                          egress_profile_matter.use_matter_values
                            ? (
                                matters.find(
                                  (x) => x.id == egress_profile_matter.matter
                                ) || {}
                              ).credits || 0
                            : egress_profile_matter.credits
                        }}
                      </b-td>
                    </b-tr>
                  </b-tbody>
                </b-table-simple>
              </template>
            </b-modal>
          </b-td>
        </b-tr>
      </b-tbody>
    </b-table-simple>
  </div>
</template>

<script>
import * as names from "@/store/names";
import { mapGetters } from "vuex";

export default {
  name: "Matrix4",
  components: {
    RenderVHtml: () => import("@/components/reusable/RenderVHtml"),
    // NewRichTextEditor: () => import("@/components/reusable/NewRichTextEditor"),
  },
  props: {
    egress_profile_id: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      institution: "getInstitution",
      matters: names.MATTERS,
      egressProfileMatters: names.EGRESS_PROFILES_MATTERS,
      formation_lines: names.FORMATION_LINES,
      competences: names.COMPETENCES,
      profile_competences: names.PROFILE_COMPETENCES,
      capacities: names.CAPACITIES,
    }),
    egressProfileMattersFilter() {
      return this.egressProfileMatters
        .filter((x) => x.egress_profile == this.egress_profile_id)
        .sort((a, b) => a.order - b.order);
    },
    getListCapacitiesIds() {
      let allCapacities = [];
      this.egressProfileMattersFilter.forEach((x) => {
        allCapacities = allCapacities.concat(x.capacities);
      });
      return [...new Set(allCapacities)];
    },
    getListCapacities() {
      return this.capacities.filter((x) =>
        this.getListCapacitiesIds.includes(x.id)
      );
    },
  },
  methods: {
    getMatterCount(capacity_id) {
      return this.egressProfileMattersFilter.filter((x) =>
        x.capacities.includes(capacity_id)
      ).length;
    },
    getMatterName(matter_id) {
      const matter = this.matters.find((x) => x.id == matter_id);
      return matter ? matter.name : "";
    },
    getMatterCode(matter_id) {
      const matter = this.matters.find((x) => x.id == matter_id);
      return matter ? matter.code : "";
    },
    getFormationLineName(formation_id) {
      const formation_line = this.formation_lines.find(
        (x) => x.id == formation_id
      );
      if (formation_line) {
        return formation_line.name;
      } else return "";
    },
    getCompetenceName(competence_id) {
      const competence = this.competences.find((x) => x.id == competence_id);
      if (competence) {
        const profile_competence = this.profile_competences.find(
          (x) =>
            x.competence == competence_id &&
            x.egress_profile == this.egress_profile_id
        );
        if (profile_competence)
          return profile_competence.order + ". " + competence.full_sentence;
        else return "";
      } else return "";
    },
  },
  watch: {},
  mounted() {},
  created() {},
};
</script>

<style scoped src="@/utils/rich_text_editor.css">
</style>

<style scope>
.container-title {
  font-size: var(--secondary-title-font-size);
  text-align: left;
}
.table-capacity {
  font-size: var(--secondary-font-size);
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}
.primary-cell-matrix4 {
  background-color: var(--kl-color-accent-medium) !important; color: var(--kl-text-on-primary) !important;
  text-align: center;
  padding: 0.6rem;
  vertical-align: middle !important;
  font-weight: bold;
}
.primary-cell-capacity {
  background-color: var(--kl-color-accent-medium);
  color: var(--kl-text-on-primary);
}
.primary-cell-capacity-modal {
  vertical-align: middle !important;
  text-align: center;
  background-color: var(--kl-color-accent-medium);
  color: var(--kl-text-on-primary);
}
.footer-matrix4 {
  background-color: var(--kl-color-accent-medium);
  color: var(--kl-text-on-primary);
  font-weight: var(--kl-fw-bold);
}
.secondary-cell-matrix4 {
  vertical-align: middle !important;
}
.competence-cell {
  width: 25%;
  max-width: 25%;
}
/* Badge de conteo alineado al chip suave del estándar (celeste + texto azul). */
.badge-footer {
  background: var(--kl-chip-bg) !important;
  color: var(--kl-chip-text) !important;
  border: 1px solid var(--kl-chip-border) !important;
  border-radius: var(--kl-radius-pill) !important;
  font-weight: var(--kl-chip-fw);
}
@media print {
  .badge-footer {
    border: none;
  }
}
</style>